module.exports = __webpack_public_path__ + "static/media/kissflow.0911a5d6.png";